import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { reconcilePush } from "../utils/pushReconcile";

// iter69 F2 — mounts once; reconciles push on app open and on every
// return to foreground (visibilitychange), for logged-in owners only.
export const PushReconciler = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return undefined;
    reconcilePush("app_open");
    const onVisible = () => {
      if (document.visibilityState === "visible") reconcilePush("visibility");
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [user]);

  return null;
};

export default PushReconciler;
